/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function FeatureFlagsReflag({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M13.833 1C14.478 1 15 1.522 15 2.167v11.666c0 .645-.522 1.167-1.167 1.167H2.167A1.167 1.167 0 0 1 1 13.833V2.167C1 1.522 1.522 1 2.167 1h11.666ZM2.167 2.167v11.666L13.833 2.167H2.167Z" clipRule="evenodd" /></svg>;
}
;